import {
  ACTION_GET_COMPANY_EMPLOYEES,
  ACTION_GET_COMPANY_EMPLOYEES_SUCCESS,
  ACTION_GET_COMPANY_EMPLOYEES_FAILURE,
  ACTION_EMPTY_COMPANY_EMPLOYEES,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../Status';

import * as _ from 'lodash-es';

export type Params = {
  keyword?: string;
  limit?: number;
  skip?: number;
};

export function getOrganizationEmployees(
  organizationId: string,
  param: Params,
  navigate: Function
) {
  return (dispatch: Dispatch) => {
    // Dispatch the api call request.
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/employees`,
        method: 'get',
        data: param,
        success: (response: any) => {
          if (response.type === 'error') {
            if (response.payload.unknownOrganization === true) {
              navigate(`/lookup`);
              return;
            }

            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload.unknownOrganization === true) {
            navigate(`/lookup`);
            return;
          }

          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function emptyResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_COMPANY_EMPLOYEES,
      payload: null,
    });
  };
}

function requestStarted() {
  return {
    type: ACTION_GET_COMPANY_EMPLOYEES,
    payload: null,
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_COMPANY_EMPLOYEES_SUCCESS,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_COMPANY_EMPLOYEES_FAILURE,
    payload: responseJSON,
  };
}
